// =============================================================================
// ADMIN ROLE STATS SLICE
// Separate from role management — stores role count statistics for dashboard
// =============================================================================

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchRoleStats } from '../thunks/adminThunks';

export interface RoleStatsState {
  totalRoles: number;
  enabledRoles: number;
  disabledRoles: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: RoleStatsState = {
  totalRoles: 0,
  enabledRoles: 0,
  disabledRoles: 0,
  isLoading: false,
  error: null,
};

const adminRoleStatsSlice = createSlice({
  name: 'adminRoleStats',
  initialState,
  reducers: {
    resetRoleStats: (state) => {
      state.totalRoles = 0;
      state.enabledRoles = 0;
      state.disabledRoles = 0;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleStats.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRoleStats.fulfilled, (state, action) => {
        state.isLoading = false;
        const stats = action.payload;
        state.totalRoles = stats.totalCount || 0;
        state.enabledRoles = stats.enabledCount || 0;
        state.disabledRoles = stats.disabledCount || 0;
      })
      .addCase(fetchRoleStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch role statistics';
      });
  },
});

export const { resetRoleStats } = adminRoleStatsSlice.actions;

// Selectors
export const selectRoleStats = (state: any) => state.adminRoleStats;
export const selectRoleStatsLoading = (state: any) => state.adminRoleStats.isLoading;
export const selectRoleStatsError = (state: any) => state.adminRoleStats.error;

export default adminRoleStatsSlice.reducer;
